import React from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import Maison from './components/Maison'
import Metiers from './components/Metiers'
import Experience from './components/Experience'
import SignatureArtistry from './components/SignatureArtistry'
import Voices from './components/Voices'
import Reservations from './components/Reservations'
import Footer from './components/Footer'
import AIChatbox from './components/AIChatbox'
import { GSAPProvider } from './hooks/useGSAP'

export default function App() {
  return (
    <GSAPProvider>
      <div className="app">
        <Header />
        <main>
          <Hero />
          <Maison />
          <Metiers />
          <Experience />
          <SignatureArtistry />
          <Voices />
          <Reservations />
        </main>
        <Footer />
        <AIChatbox />
      </div>
    </GSAPProvider>
  )
}